export default __webpack_public_path__ + "static/media/Snd1.d849702e.mp3";